import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    duplicates: {
      selectIds: [],
      filters: {}
    }
  },
  mutations: {
    SET_DUPLICATE_SELECT_IDS (store, ids) {
      store.duplicates.selectIds = ids
    },
    REMOVE_DUPLICATE_SELECT_IDS (store, ids) {
      store.duplicates.selectIds = store.duplicates.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_DUPLICATE_FILTERS (store, filters) {
      store.duplicates.filters = filters
    }
  },
  getters: {
    getDuplicates: (store, getters) => {
      return store.duplicates.selectIds.map((id) => {
        return getters['entities/candidates/query']()
        .find(id)
      })
    },
    getDuplicatesFilters: (store, getters) => {
      return store.duplicates.filters
    }
  },
  actions: {
    /*
    selectDuplicates
    */
    selectDuplicates ({commit, dispatch, getters, state}, filters) {
      return dispatch('getDuplicates', filters)
      .then((response) => {
        commit('SET_DUPLICATE_FILTERS', filters)
        commit('SET_DUPLICATE_SELECT_IDS', response.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectDuplicates
    */
    refreshSelectDuplicates ({commit, dispatch, getters, state}) {
      return dispatch('selectDuplicates', getters.getDuplicatesFilters)
    },
    /*
    getDuplicates
    */
    getDuplicates ({commit, dispatch, getters, state}, filters) {
      const candidateId = filters.candidate_id
      delete filters.candidate_id

      return axios
      .get(`/accounts/${getters.getAccount._id}/candidates/${candidateId}/duplicates`, {params: filters})
      .then((response) => {
        return dispatch('entities/candidates/insertOrUpdate', {
          data: response.data
        })
        .then((result) => {
          return getters['entities/candidates/findIn'](response.data.map(v => v._id)) // insertOrUpdate traz o resultado ordenado
        })
      })
    },
    /*
    mergeCandidate
    */
    mergeCandidate ({commit, dispatch, getters, state}, data) {
      delete data.$id

      const candidateId = data.candidate_id
      delete data.candidate_id

      return axios
      .put(`/accounts/${getters.getAccount._id}/candidates/${candidateId}/merge`, data)
      .then((response) => {
        return response
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/CandidateDuplicates.js